import React from 'react';

const Logo = ({ size = 40 }) => {
  return (
    <div style={{ 
      margin: '0 auto', 
      width: size, 
      height: size, 
      borderRadius: '50%', 
      background: 'linear-gradient(135deg, #a288e3 0%, #63e0ff 100%)',
      boxShadow: '0 0 20px rgba(99, 224, 255, 0.5), 0 0 40px rgba(162, 136, 227, 0.3)',
      position: 'relative',
      marginBottom: '1rem'
    }}>
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: size * 0.5,
        height: size * 0.5,
        borderRadius: '50%',
        background: 'rgba(15, 15, 31, 0.8)',
        boxShadow: 'inset 0 0 10px rgba(99, 224, 255, 0.5)'
      }}></div>
    </div>
  );
};

export default Logo;